<mat-dialog-actions>
  <div class="dialog-close">
    <i class="fas fa-window-minimize" (click)="onMinimizeClick()" title="Minimize"></i>
    <i class="fas fa-times" (click)="onDialogCloseClick()" title="Close"></i>
  </div>
  <div mat-dialog-title>New Injury</div>
</mat-dialog-actions>

<mat-dialog-content>
  <div class="info">
    For safety assistance, please call Laura Hall: 443-977-0541
    <br />If you need after hours substance testing, please call 1-800-416-6753
  </div>

  <mat-stepper #stepper (selectionChange)="onStepChange($event)">
    <ng-template matStepperIcon="edit">
      <mat-icon>check</mat-icon>
    </ng-template>

    <!-- Driver Info Step -->
    <mat-step [stepControl]="driverInfoFormGroup">
      <form [formGroup]="injuryForm">
        <ng-template matStepLabel>Driver Info</ng-template>
        <app-step-driver-info
          [driverInfoForm]="driverInfoFormGroup"
          [preloadedData]="data"
        ></app-step-driver-info>
      </form>
    </mat-step>

    <!-- Time & Place Step -->
    <mat-step [stepControl]="timePlaceFormGroup">
      <form [formGroup]="injuryForm">
        <ng-template matStepLabel>Time & Place</ng-template>
        <app-step-time-place [timePlaceForm]="timePlaceFormGroup"></app-step-time-place>
      </form>
    </mat-step>

    <!-- Injury Detail Step -->
    <mat-step [stepControl]="injuryDetailFormGroup">
      <form [formGroup]="injuryForm">
        <ng-template matStepLabel>Injury Detail</ng-template>
        <app-step-injury-detail
          [injuryDetailForm]="injuryDetailFormGroup"
        ></app-step-injury-detail>
      </form>
    </mat-step>

    <!-- Injury Description Step -->
    <mat-step [stepControl]="injuryDescriptionFormGroup">
      <form [formGroup]="injuryForm">
        <ng-template matStepLabel>Injury Description</ng-template>
        <app-step-injury-description
          [injuryDescriptionForm]="injuryDescriptionFormGroup"
          (filesChanged)="onInjuryImagesChanged($event)"
        ></app-step-injury-description>
      </form>
    </mat-step>

    <!-- Leave Step -->
    <mat-step [stepControl]="leaveFormGroup">
      <form [formGroup]="injuryForm">
        <ng-template matStepLabel>Leave</ng-template>
        <app-step-leave [leaveForm]="leaveFormGroup"></app-step-leave>
      </form>
    </mat-step>
  </mat-stepper>
</mat-dialog-content>

<mat-dialog-actions class="action-buttons">
  <button
    mat-flat-button
    color="primary"
    (click)="onDoneClick()"
    *ngIf="step === maxStep - 1"
    [disabled]="injuryForm.invalid || isSaving"
  >
    <mat-spinner
      *ngIf="isSaving"
      diameter="16"
      style="margin-right: 8px; color: var(--shade1)"
    ></mat-spinner>
    Done
  </button>
  <button
    mat-flat-button
    color="primary"
    (click)="nextStep()"
    *ngIf="step < maxStep - 1"
    [disabled]="!driverNameValue"
  >
    Next
  </button>
  <button
    mat-flat-button
    color="primary"
    (click)="onSaveClick()"
    *ngIf="step < maxStep - 1 && step > 0"
    [disabled]="!driverNameValue || !dateReport || !dateInjury || isSaving"
  >
    <mat-spinner
      *ngIf="isSaving"
      diameter="16"
      style="margin-right: 8px; color: var(--shade1)"
    ></mat-spinner>
    Save and Finish Later
  </button>
  <button
    mat-stroked-button
    color="primary"
    *ngIf="step !== 0 && step !== maxStep - 1"
    (click)="prevStep()"
  >
    Back
  </button>
  <button
    mat-stroked-button
    color="warn"
    (click)="onDialogCloseClick()"
    *ngIf="step === 0"
  >
    Cancel
  </button>
  <button mat-stroked-button color="warn" (click)="reset()" *ngIf="step === maxStep - 1">
    Reset
  </button>
</mat-dialog-actions>
